import React from 'react'
import {useI18n} from 'i18n/I18nContext'
import {LocalLink} from 'i18n/LocalLink'
import {routes} from 'routes/routes'

type OrgPromoOfferBannerProps = {
  inviteToken: string
  variant: 'register' | 'login'
}

function maskInviteToken(token: string): string {
  const t = token.trim()
  if (t.length <= 10) {
    return '••••'
  }

  return `••••${t.slice(-10)}`
}

export function OrgPromoOfferBanner({inviteToken, variant}: OrgPromoOfferBannerProps) {
  const {t} = useI18n()
  const registerTo = `${routes.organization.register}?invite=${encodeURIComponent(inviteToken)}`

  return (
    <aside
      className="org-promo-offer-banner"
      role="status"
      aria-live="polite"
    >
      <div className="org-promo-offer-banner__title">
        {t('auth.orgPromoOfferBannerTitle')}
      </div>

      <div className="org-promo-offer-banner__label">
        {t('auth.orgPromoOfferPackageLabel')}
      </div>
      <span className="org-promo-offer-banner__token" title={t('auth.orgPromoOfferTokenTooltip')}>
        {maskInviteToken(inviteToken)}
      </span>

      {variant === 'login' ? (
        <p className="org-promo-offer-banner__body">{t('auth.orgPromoLoginBannerBody')}</p>
      ) : null}

      {variant === 'login' ? (
        <div>
          <LocalLink to={registerTo} className="org-promo-offer-banner__cta">
            {t('auth.orgPromoLoginRegisterCta')}
          </LocalLink>
        </div>
      ) : null}
    </aside>
  )
}
